import React from 'react';

import type { CardProps } from '@/cms/Card';
import { CMSSection } from '@/cms/CMSSection';
import type { ProductCardProps } from '@/cms/ProductCard';
import { Container } from '@/components/Container';
import type { ContentfulContentGroupFragment } from '@/graphql/contentful/api';
import type {
  CmsExtraDataRecord,
  ContentfulData,
} from '@/integrations/contentful';
import { generateSectionKey } from '@/integrations/contentful';
import { generateDataTestId } from '@/lib/tests';
import type { WithHTMLProp } from '@/lib/types';

import type { NavQuickLinksProps } from '../DoubleCard/DoubleCard';
import { renderCollectionItem } from '../DoubleCard/DoubleCard';

import * as S from './DoubleCardWide.styles';

type DoubleCardWideProps = ContentfulContentGroupFragment & {
  extraDataRecord?: CmsExtraDataRecord;
} & WithHTMLProp<'className'>;

export const DoubleCardWide = ({
  className,
  extraDataRecord,
  itemsCollection,
}: DoubleCardWideProps) => {
  return (
    <CMSSection
      className={className}
      {...generateDataTestId('DoubleCardWide', 'section')}
    >
      <Container maxWidth='xl'>
        <S.Wrapper>
          {itemsCollection?.items.filter(Boolean).map((item, i) => {
            const props = (item ? { ...item } : null) as ItemData;
            if (props) {
              props.preload = true;
            }
            const renderedItem = renderCollectionItem(props, extraDataRecord);

            return (
              renderedItem && (
                <S.Col
                  key={generateSectionKey((item as ContentfulData)!, i)}
                  md={6}
                >
                  {renderCollectionItem(item! as ItemData, extraDataRecord)}
                </S.Col>
              )
            );
          })}
        </S.Wrapper>
      </Container>
    </CMSSection>
  );
};

type ItemData = CardProps | ProductCardProps | NavQuickLinksProps | null;

DoubleCardWide.displayName = 'DoubleCardWide';
